export default __webpack_public_path__ + "static/media/PLN.5a99838b.svg";